import { useGetAssistantQuery } from '@/store/api/assistantApi';

export const useGetAssistant = (assistantId: string) =>
  useGetAssistantQuery({ assistantId });
